module.exports = __webpack_public_path__ + "static/media/page1.aa70684b.png";